module.exports = __webpack_public_path__ + "img/2.2e9f1386.png";